'use client'

import { motion } from 'motion/react'
import type { PropsWithChildren, Ref } from 'react'
import { useMeasure } from 'react-use'

export default function AnimatedContainer({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  const [ref, { height }] = useMeasure()

  return (
    <motion.div animate={{ height }} transition={{ duration: 0.25 }}>
      <div ref={ref as Ref<HTMLDivElement>} className={className}>
        {children}
      </div>
    </motion.div>
  )
}
